module.exports = __webpack_public_path__ + "img/IMG_0577_8_9_L_WoodMatted_MockedUp.91406f06.jpg";